import React from "react";
import Header from "../header";
import SpaceDiv from "../spaceDiv";
import Footer from "../footer";
import ContactForm from "./Contact";
import WhatsappIcon from "../whatsAppIcon";
import { Box, Button } from "@mui/material";

const ContactUs = () => {
  return (
    <div>
      <Header />
      <SpaceDiv />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          gap: 2,
          my: 2, // Adds margin for spacing
        }}
      >
        <Button
          variant="contained"
          sx={{
            boxShadow: 'none',
            fontSize: '1.5rem',
            textTransform: 'none', // Preserve original casing
          }}
          onClick={() => window.open('tel:917015006321', '_self')}
        >
          Call To Rent
        </Button>
        <h2>
            OR
        </h2>
        <div style={{padding:'10px'}}>
        <WhatsappIcon color='black'/>
        </div>
      </Box>
      <h2 style={{textAlign:'center'}}>
            OR
      </h2>
      <ContactForm />
      <SpaceDiv />
      <Footer />
    </div>
  );
};

export default ContactUs;
